import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';
import styled from 'styled-components';

import { radioOptions } from 'constants/reviews';
import { Row, Separator, Text, Button } from '@cuemath/comps';

const ButtonStyle = styled.span`
  padding-left: 30px;
`;

const GridItems = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  padding: 5px;
`;

const DivStyle = styled.div`
  margin-left: 17%;
`;

const Label = styled.label`
  display: flex;
`;

const Input = styled.input`
  height: 16px;
  width: 16px;
  margin-top: 2px;
`;

const RadioStyle = styled.span`
  margin-left: 5px;
`;

const ModalTitle = styled(Text)`
  margin-left: ${({ isOngoing }) => (isOngoing ? `42px` : `38px`)};
`;

const ModalWrapper = styled.div`
  border: 2px solid black;
  margin: 10px;
  padding: ${({ isOngoing }) => (isOngoing ? `30px` : `55px`)};
`;

const TextDiv = styled.div`
  padding-left: 20px;
  padding-right: 10px;
`;

class ReviewType extends Component {
  static propTypes = {
    actions: Proptypes.shape({
      closeModal: Proptypes.func.isRequired,
    }).isRequired,
    onReviewTypeSelected: Proptypes.func.isRequired,
    callLogData: Proptypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    };
  }

  handleCancel = () => {
    const { actions } = this.props;

    actions.closeModal();
  };

  onOptionSelected = (id, value) => {
    this.setState({
      selectedOption: {
        id,
        value,
      },
    });
  };

  render() {
    const { onReviewTypeSelected, callLogData } = this.props;

    const { data } = callLogData || {};
    const { class_reviews: classReviews } = data || {};

    const isOngoing =
      classReviews && Array.isArray(classReviews) && classReviews.length ? true : false;

    const [ongoingObj] = classReviews || [];

    const newOptions = isOngoing
      ? radioOptions.filter(rad => rad.id !== ongoingObj.review_type)
      : '';

    const optionsArr = isOngoing ? newOptions : radioOptions;

    const { selectedOption } = this.state;

    return (
      <React.Fragment>
        <ModalWrapper isOngoing={isOngoing}>
          <Row>
            <ModalTitle weight="bold" size="large" isOngoing={isOngoing}>
              {!isOngoing ? `Select review type` : `Edit Review Type`}
            </ModalTitle>
          </Row>
          <Separator height={10} transparent />
          <DivStyle>
            {optionsArr.map(opt => {
              const { id, value } = opt;
              return (
                <GridItems>
                  <Label key={`radio.${id}`}>
                    <Input
                      type="radio"
                      name="review_type"
                      onChange={() => this.onOptionSelected(id, value)}
                      value={value}
                    />
                    <RadioStyle>{value}</RadioStyle>
                  </Label>
                </GridItems>
              );
            })}
          </DivStyle>
          <Separator height={10} transparent />
          {isOngoing ? (
            <TextDiv>
              <Text>The review progress in the current type will be lost.</Text>
              <Separator height={10} transparent />
              <Text>Proceed with the changes?</Text>
              <Separator height={20} transparent />
            </TextDiv>
          ) : (
            ''
          )}

          {!isOngoing && (
            <Row justifyContent="center">
              <Button
                label="Next"
                onClick={() => onReviewTypeSelected(selectedOption)}
                disabled={!selectedOption}
              />
            </Row>
          )}

          {isOngoing ? (
            <Row justifyContent="center">
              <Button
                label="No"
                onClick={() => this.handleCancel()}
                disabled={!selectedOption}
              />
              <ButtonStyle>
                <Button
                  label="Yes"
                  onClick={() => onReviewTypeSelected(selectedOption)}
                  disabled={!selectedOption}
                />
              </ButtonStyle>
            </Row>
          ) : (
            ''
          )}
          <Separator height={10} transparent />
        </ModalWrapper>
      </React.Fragment>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators({ closeModal }, dispatch),
}))(ReviewType);
